import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Criar instância do axios com configurações padrão
const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 30000, // 30 segundos
});

// Variável para armazenar a função de logout
let logoutCallback = null;

// Função para configurar o callback de logout
export const setLogoutCallback = (callback) => {
  logoutCallback = callback;
};

// Interceptor de requisição - adiciona o token automaticamente
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de resposta - trata erros de autenticação
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Verificar se é erro de autenticação
    if (error.response) {
      const status = error.response.status;
      
      if (status === 401 || status === 403) {
        // Token inválido ou expirado
        console.warn('Sessão expirada ou inválida. Redirecionando para login...');
        
        // Limpar dados de autenticação
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        
        // Mostrar mensagem
        toast.error('Sessão expirada. Por favor, faça login novamente.');
        
        // Chamar callback de logout se configurado
        if (logoutCallback) {
          logoutCallback();
        }
        
        // Redirecionar para login
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      } else if (status === 500) {
        // Erro interno do servidor
        toast.error('Erro no servidor. Tente novamente em alguns instantes.');
      } else if (status === 502 || status === 503 || status === 504) {
        // Servidor indisponível (pode estar "acordando")
        toast.error('Servidor temporariamente indisponível. Aguarde alguns segundos e tente novamente.');
      }
    } else if (error.code === 'ECONNABORTED') {
      // Timeout
      toast.error('A requisição demorou muito. Verifique sua conexão.');
    } else if (!error.response) {
      // Erro de rede
      toast.error('Erro de conexão. Verifique sua internet.');
    }
    
    return Promise.reject(error);
  }
);

export default api;
